module.exports = __webpack_public_path__ + "img/primary-rule.b88f8550.svg";